import {hoistCmp} from '@xh/hoist/core';
import {toolbar} from '@xh/hoist/desktop/cmp/toolbar';
import './WidgetToolbar.scss';

export const widgetToolbar = hoistCmp.factory({
    className: 'rzx-widget-toolbar',
    render: ({className, ...rest}) => toolbar({className, ...rest})
});
